/* UI-only quote entry points. Existing native quote/cart controllers own state. */
(() => {
  if (window.__amcPurchaseActions) return;
  window.__amcPurchaseActions = true;
  function sync(form) {
    const variant = form.querySelector('[name="id"]');
    const cart = form.querySelector('button[name="add"]');
    form.querySelectorAll('[data-amc-qadd]').forEach(button => {
      button.disabled = !variant?.value || !!cart?.disabled;
    });
  }
  function boot() {
    document.querySelectorAll('product-card modal-opener button:not(:disabled)').forEach(button => {
      const walker = document.createTreeWalker(button, NodeFilter.SHOW_TEXT);
      while (walker.nextNode()) {
        if (/^(add to cart|choose options)$/i.test(walker.currentNode.textContent.trim())) walker.currentNode.textContent = 'Quick add';
      }
    });
    document.querySelectorAll('form[data-amc-home-option-form]').forEach(form => {
      if (form.dataset.amcQuoteSync) return;
      form.dataset.amcQuoteSync = 'true';
      form.addEventListener('change', () => queueMicrotask(() => sync(form)));
      form.addEventListener('input', () => queueMicrotask(() => sync(form)));
      const cartButton = form.querySelector('button[name="add"]');
      if (cartButton) new MutationObserver(() => sync(form)).observe(cartButton, {attributes:true,attributeFilter:['disabled']});
      sync(form);
    });
  }
  document.addEventListener('click', event => {
    const opener = event.target.closest('modal-opener[data-modal]');
    if (!opener) return;
    const id = opener.getAttribute('data-modal')?.replace(/^#/,'');
    if (!id || document.getElementById(id)) return;
    const template = document.querySelector(`template[data-amc-modal-template="${CSS.escape(id)}"]`);
    if (!template) return;
    const fragment = template.content.cloneNode(true);
    const node = fragment.firstElementChild;
    template.after(fragment);
    node?.dispatchEvent(new CustomEvent('shopify:section:load',{bubbles:true}));
  }, true);
  document.addEventListener('click', event => {
    const quote = event.target.closest('[data-amc-quote-card]');
    if (!quote || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const card = quote.closest('.amc-market-card,.amc-cslider__card,product-card');
    const opener = card?.querySelector('modal-opener button');
    if (opener) {
      event.preventDefault();
      opener.click();
    }
  });
  document.addEventListener('shopify:section:load', boot);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
